import { useTranslation } from '@morningtrain/react-translations'
import startCase from 'lodash/startCase'

export default BaseComponent => ({ name, ...props }) => {
  const defaultValue = startCase(name)

  const propsToTranslate = [
    'label',
    'placeholder'
  ]

  const newProps = {}

  if (name) {
    const nameTrans = useTranslation(name, {}, defaultValue)
    const namePlaceholderTrans = useTranslation([name, 'placeholder'].join('.'), {}, defaultValue)
    const nameLabelTrans = useTranslation([name, 'label'].join('.'), {}, defaultValue)

    propsToTranslate.forEach(propName => {
      if (React.isValidElement(props[propName])) {
        return
      }

      if (!name) {
        return
      }

      const translation = nameTrans

      if (!Array.isArray(translation) && translation !== defaultValue) {
        newProps[propName] = translation
        return
      }

      /// Make early return if placeholder - default should be none
      if (propName === 'placeholder') {
        return
      }

      if (propName === 'label') {
        newProps[propName] = nameLabelTrans
      }
    })
  }

  return (
    <BaseComponent
      {...newProps}
      {...props}
      name={name}
    />
  )
}
